export const Theme = {
    colors: {
      base1: "#9dd1e2", // deep blue background [navbar, about , contact]
      base2: "#fff", //white
      primary: "#87CEEB", //lighter blue
      primary1: "#4682B4", // deepest blue [portfolio, footer]
    },
  };